import caver, { kaikasCaver } from "src/modules/klaytn/caver";
import { governanceAbi } from 'src/modules/abi/governance'
import GLOBAL from "src/variables/globals";
export const governanceContract = new kaikasCaver.klay.Contract(governanceAbi as [], GLOBAL.KLAYTN.VOTING_CONTRACT_ADDR)
export const governanceCallContract = new caver.klay.Contract(governanceAbi as [], GLOBAL.KLAYTN.VOTING_CONTRACT_ADDR)